import { AvailableHoursPVData } from './AvailableHoursPVMapper.types'

class AvailableHoursPVMapper {
  toDomain(persistenceData: AvailableHoursPVData) {
    return {
      hour: persistenceData?.horario,
      hourId: persistenceData?.idHorario,
    }
  }
}

export default new AvailableHoursPVMapper()
